import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateInvestmentForm } from "web_myplann/Portfolio/Pages/InvestmentCreate/CreateInvestmentForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddInvestmentPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddInvestment.title)}>
			<CreateInvestmentForm />
		</PortfolioAddLayout>
	);
};
